'use client';

import { useState, useEffect } from 'react';

import { useMediaQuery, Theme } from '@mui/material';

interface UseManualStateProps {
  initialStep?: number;
  steps?: StepData[];
  guide?: GuideData;
  siblings?: GuideData[];
}

export function useManualState({ initialStep = 0, steps = [] }: UseManualStateProps) {
  const isMdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  const [activeStep, setActiveStep] = useState(initialStep);
  const [activePhoto, setActivePhoto] = useState(0);
  const [sidebar, setSidebar] = useState<'contents' | 'comments' | null>(null);

  // Handle sidebar persistence
  useEffect(() => {
    const hash = window.location.hash;
    if (hash && hash.includes('comment-')) {
      setSidebar('comments');
    } else {
      if (isMdDown) {
        setSidebar(null);
      } else {
        const savedState = localStorage.getItem('manualSidebar');
        if (savedState === 'contents' || savedState === 'comments') {
          setSidebar(savedState);
        }
      }
    }
  }, []);

  const updateSidebar = (newState: 'contents' | 'comments' | null, save: boolean = true) => {
    if (save) {
      if (newState === null) {
        localStorage.removeItem('manualSidebar');
      } else {
        localStorage.setItem('manualSidebar', newState);
      }
    }
    setSidebar(newState);
  };

  // Get current step title
  const currentTitle = steps?.[activeStep]?.title ? `${activeStep + 1}. ${steps[activeStep].title}` : '';

  return {
    activeStep,
    setActiveStep,
    activePhoto,
    setActivePhoto,
    sidebar,
    updateSidebar,
    currentTitle,
  };
}
